import React from 'react';
import { isTotalCountMeasurement } from '../services/performanceItemService';

/**
 * @typedef {object} PerformanceItemInfoDetailsProps
 * @property {Object} [performanceItem]
 */

/**
 * @param {PerformanceItemInfoDetailsProps} props
 */
const PerformanceItemInfoDetails = props => {
  const { performanceItem } = props;
  return (
    <>
      <span className='graph-name'>{performanceItem.MeasurementName}</span>
      <ul
        className='report-info-panel__list no-pandding list-style'
        data-testid='performance-item-info-details'>
        <li>
          <strong>Quality Domain: </strong>
          {performanceItem.QualityDomain}
        </li>
        <li>
          <strong>Domain Definition: </strong>
          {performanceItem.DomainDefinition}
        </li>
        <li>
          <strong>Business Objective: </strong>
          {performanceItem.BusinessObjective}
        </li>
        <li>
          <strong>Quality Objective: </strong>
          {performanceItem.QualityObjective}
        </li>
        <li>
          <strong>Level of Measure: </strong>
          {performanceItem.MeasurementLevel}
        </li>
        <li>
          <strong>Description: </strong>
          {performanceItem.MeasurementDescription}
        </li>
        <li>
          <strong>Indication of Improvement: </strong>
          {performanceItem.GoodPerformanceIndicator}
        </li>
        <li>
          <strong>Calculation: </strong>
          {performanceItem.MeasurementCalculation}
        </li>

        {isTotalCountMeasurement(performanceItem.MeasurementCalculationId) ? (
          <li>
            <strong>Unit of Measure: </strong>
            {performanceItem.MeasurementUnit}
          </li>
        ) : (
          <>
            <li>
              <strong>Numerator: </strong>
              {performanceItem.Numerator}
            </li>
            <li>
              <strong>Denominator: </strong>
              {performanceItem.Denominator}
            </li>
          </>
        )}

        <li>
          <strong>Time Bound: </strong>
          {performanceItem.TimeBound}
        </li>
        {(performanceItem.TimeBound === 'Period of Time' ||
          performanceItem.TimeBound === 'Rolling Time') && (
          <li>
            <strong>Timeframe: </strong>
            {performanceItem.TimeFrame}
          </li>
        )}
        <li>
          <strong>Blind Spots: </strong>
          {performanceItem.BlindSpots}
        </li>
        <li>
          <strong>How Metric is used: </strong>
          {performanceItem.MeasurementUse}
        </li>
        <li>
          <strong>Captured: </strong>
          {performanceItem.CaptureFrequency}
        </li>
        <li>
          <strong>Reported: </strong>
          {performanceItem.ReportFrequency}
        </li>
      </ul>
    </>
  );
};

export default PerformanceItemInfoDetails;
